import React, { useEffect } from "react";
import { Table } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import organizationsStatisticsAtions from "../../../redux/organizationsStatistics/actions";
import { useProjectState } from "../../../context/stateContext";

const AdminOrganizationsStatistics = ({
  setStatisticsArray,
  statisticsTypeValue,
  statisticsArray,
}) => {
  const dispatch = useDispatch();
  const { organizationsStatistics, loading } = useSelector(
    (state) => state.organizationsStatisticsReducer
  );
  const { startDate, endDate } = useProjectState();

  const {
    getAllOrganizationsStatistics,
    getAllOrganizationsByDatesStatistics,
  } = organizationsStatisticsAtions;

  useEffect(() => {
    setStatisticsArray(organizationsStatistics);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationsStatistics]);

  useEffect(() => {
    dispatch(getAllOrganizationsStatistics());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const formattedStartDate = startDate.replace(/\//g, "-");
      const formattedEndDate = endDate.replace(/\//g, "-");
      dispatch(
        getAllOrganizationsByDatesStatistics(
          formattedStartDate,
          formattedEndDate
        )
      );
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const getTotalValueFromColums = (day, byDates) => {
    if (byDates) {
      return statisticsArray
        ?.map((item) => {
          if (statisticsTypeValue === "visits") {
            return item.visitsByDates;
          } else if (statisticsTypeValue === "orders") {
            return item.ordersByDates;
          } else {
            return item.myPosPaymentsByDates;
          }
        })
        ?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    } else {
      return statisticsArray
        ?.map((item) => item[statisticsTypeValue][day])
        ?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    }
  };

  const currentDate = dayjs();

  const formattedDate = currentDate.format("YYYY-MM-DD");

  const adminOrganizationsStatisticsTableColumn = [
    {
      title: "Заведение",
      dataIndex: "organizationName",
      align: "left",
    },
    {
      title: `${
        startDate === formattedDate && endDate === formattedDate
          ? "Днес"
          : `${dayjs(startDate).format("DD")}.${dayjs(startDate).format(
              "MM"
            )}.${dayjs(startDate).format("YY")} - ${dayjs(endDate).format(
              "DD"
            )}.${dayjs(endDate).format("MM")}.${dayjs(endDate).format("YY")}`
      } (${getTotalValueFromColums("today", true)})`,
      dataIndex: "today",
      render: (text, record) => (
        <p className="admin-organizations-statistics-column-heading">
          {statisticsTypeValue === "visits"
            ? record.visitsByDates
            : statisticsTypeValue === "orders"
            ? record.ordersByDates
            : record.myPosPaymentsByDates}
        </p>
      ),
      align: "center",
      sorter: (a, b) =>
        statisticsTypeValue === "visits"
          ? a.visitsByDates - b.visitsByDates
          : statisticsTypeValue === "orders"
          ? a.ordersByDates - b.ordersByDates
          : a.myPosPaymentsByDates - b.myPosPaymentsByDates,
    },
    {
      title: `Вчера (${getTotalValueFromColums("yesterday", false)})`,
      dataIndex: "yestarday",
      render: (text, record) => (
        <p className="admin-organizations-statistics-column-heading">
          {record[statisticsTypeValue].yesterday}
        </p>
      ),
      align: "center",
      sorter: (a, b) =>
        a[statisticsTypeValue].yesterday - b[statisticsTypeValue].yesterday,
    },
    {
      title: `Последните 7 дни (${getTotalValueFromColums("lastWeek", false)})`,
      dataIndex: "lastweek",
      render: (text, record) => (
        <p className="admin-organizations-statistics-column-heading">
          {record[statisticsTypeValue].lastWeek}
        </p>
      ),
      align: "center",
      sorter: (a, b) =>
        a[statisticsTypeValue].lastWeek - b[statisticsTypeValue].lastWeek,
    },
    {
      title: `Последните 30 дни (${getTotalValueFromColums(
        "lastMonth",
        false
      )})`,
      dataIndex: "lastMonth",
      render: (text, record) => (
        <p className="admin-organizations-statistics-column-heading">
          {record[statisticsTypeValue].lastMonth}
        </p>
      ),
      align: "right",
      sorter: (a, b) =>
        a[statisticsTypeValue].lastMonth - b[statisticsTypeValue].lastMonth,
    },
  ];

  return (
    <>
      <Table
        className="admin-organizations-statistics-table"
        size="small"
        loading={organizationsStatistics?.length === 0 && loading}
        columns={adminOrganizationsStatisticsTableColumn}
        dataSource={statisticsArray?.filter(
          (org) => org[statisticsTypeValue]?.allTime !== 0
        )}
        rowKey="organizationId"
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
      />
    </>
  );
};
export default AdminOrganizationsStatistics;
